import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dispatchAuthenticationFactorsRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  FDDialogActions,
  FDDialogContent,
  FDPrimaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import ErrorList from 'Components/UI/ErrorList';

const Layout = ({ onSuccess }) => {
  const { handleChange, onSubmit, errors } = useMetaLayoutContext();
  const { displayInfo, displaySuccess } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleSubmit = async () => {
    const resp = await onSubmit();

    if (resp) {
      displaySuccess('SMS enabled');
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: submit code');
      dispatchAuthenticationFactorsRefresh();
      onSuccess();
    }
  };

  const handleResendCode = async () => {
    handleChange('resend', 'true');
    const resp = await onSubmit();
    if (resp) {
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Sms: resend code');
      displayInfo('Code has been resent.');
    }
  };

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <MetaControlField attr={'primaryText'} />
          <MetaControlField attr={'code'} fullWidth />
          <FDTextButton
            label={'I didn\'t receive a code'}
            fullWidth
            onClick={handleResendCode}
          />
          <ErrorList title={'Errors occurred while submitting'} errors={errors} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          fullWidth
          onClick={handleSubmit}
          test={'security-settings-button-sms-register-modal-submit-code'}
        />
      </FDDialogActions>
    </>

  );
};

Layout.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default Layout;
